'use client'

import { getDefaultProfile } from './data/industries'
import { useMiniDashboardState } from './state'
import { MiniDashboardShell } from './mini-dashboard-shell'
import { PromptsPage } from './pages/prompts-page'
import { CompetitorsPage } from './pages/competitors-page'
import { PlanPage } from './pages/plan-page'
import { SourcesPage } from './pages/sources-page'
import { VisibilityPage } from './pages/visibility-page'
import { getSamplePlanSummary } from './data/plan-summary'

const defaultProfile = getDefaultProfile()
const planSummary = getSamplePlanSummary(defaultProfile)

export function MiniDashboard() {
  const profile = defaultProfile
  const state = useMiniDashboardState()

  function handleToggleRow(id: string) {
    state.setExpandedRowId(id === '' || id === state.expandedRowId ? null : id)
  }

  function renderPage() {
    switch (state.activePage) {
      case 'prompts':
        return (
          <PromptsPage
            prompts={profile.prompts}
            expandedRowId={state.expandedRowId}
            onToggleRow={handleToggleRow}
          />
        )
      case 'competitors':
        return (
          <CompetitorsPage
            brand={profile.brand}
            brandShare={planSummary.visibility}
            brandPerEngine={planSummary.perEngine}
            competitors={profile.competitors}
            prompts={profile.prompts}
            selectedCompetitorId={state.selectedCompetitorId}
            onSelectCompetitor={state.setSelectedCompetitorId}
          />
        )
      case 'plan':
        return <PlanPage summary={planSummary} />
      case 'sources':
        return (
          <SourcesPage
            sources={profile.sources}
            prompts={profile.prompts}
            expandedRowId={state.expandedRowId}
            onToggleRow={handleToggleRow}
          />
        )
      case 'visibility':
        return <VisibilityPage visibility={profile.visibility} />
      default:
        return null
    }
  }

  return (
    <MiniDashboardShell
      activePage={state.activePage}
      onNavigate={(page) => {
        state.setActivePage(page)
        state.setExpandedRowId(null)
        state.setSelectedCompetitorId(null)
      }}
      brandName={profile.brand.name}
      domain={profile.brand.domain}
      lastScannedAt={profile.lastScannedAt}
    >
      {renderPage()}
    </MiniDashboardShell>
  )
}
